import VTLogo from './assets/logo.svg?react';
import * as styles from './styles.css';

const Logo = () => <VTLogo className={styles.logo} aria-label="Varsity Tutors" role="img" />;

export default Logo;
